<script>
import { authComputed, personnelComputed } from '@state/helpers'
import moment from 'moment-timezone'
import { getMyAssignedProspects, getProspectAssignedById } from '@src/api/personnelManagement'
import ModalNewProspectPrompt from '@components/modal-new-prospect-prompt.vue'
import ProspectRider from '@components/prospect-rider.vue'

export default {
  components: { ProspectRider, ModalNewProspectPrompt },
  computed: {
    ...authComputed,
    ...personnelComputed,
    hasProspects() {
      return this.prospects?.length > 0
    },
  },
  created() {
    const prospectAssignedId = localStorage.getItem('prospectAssignedId')
    if (prospectAssignedId) {
      this.prospectByAssignedUserId(prospectAssignedId)
      return
    }
    if (this.isBoOrOpsManager) {
      this.checkProspectForOffice()
    }
  },
  methods: {
    async prospectByAssignedUserId(prospectAssignedId) {
      localStorage.removeItem('prospectAssignedId')
      const { data: prospect } = await getProspectAssignedById(prospectAssignedId)

      if (!prospect) {
        return
      }

      if (this.isProspectExpired(prospect.expiredAt)) {
        this.$bvToast.toast('This Motto Recruit assignment has expired.', {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
        await this.checkProspectForOffice()
        return
      }

      this.$store.commit('personnel/SET_PROSPECTS', [prospect])
      this.openProspect()
    },
    async checkProspectForOffice() {
      if (!this.isBoOrOpsManager) {
        return
      }

      const {
        data: { data: prospects },
      } = await getMyAssignedProspects()

      this.$store.commit('personnel/SET_PROSPECTS', prospects)
      if (this.hasProspects > 0 && (!this.lastProspectIdPrompt || this.prospects[0].id > this.lastProspectIdPrompt)) {
        this.openProspect()
      }
    },
    isProspectExpired(expiredAtUtc) {
      const userTimezone = moment.tz.guess()

      const now = moment.tz(userTimezone)
      const expiredAt = moment.utc(expiredAtUtc).tz(userTimezone)

      return now.isAfter(expiredAt)
    },
    openProspect() {
      this.$bvModal.show('modalNewProspectPrompt')
    },
  },
}
</script>

<template>
  <div>
    <ModalNewProspectPrompt v-if="hasProspects" :prospect="prospects[0]" />
    <ProspectRider v-if="hasProspects" :prospect="prospects[0]" @openProspect="openProspect"></ProspectRider>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
